// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/bankDetails/stylesheets/bankDetails.scss
 ** module id = 399
 ** module chunks = 1
 **/